module.exports = __webpack_public_path__ + "static/media/Jam2.dbc9ae8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/Jam2.svg
// module id = 603
// module chunks = 0